import React, { Component } from 'react';
import { graphql, createRefetchContainer } from 'react-relay';
import { Table, TableBody, TableRow, TableHeader, TableHeaderColumn } from 'material-ui/Table';
import IconArrowDown from 'material-ui/svg-icons/navigation/arrow-drop-down';
import IconArrowUp from 'material-ui/svg-icons/navigation/arrow-drop-up';
import Paper from 'material-ui/Paper';
import RaisedButton from 'material-ui/RaisedButton';
import { withRouter } from 'react-router-dom';
import UserListItem from './UserListItem';

import './users.css';

const fabStyle = {
	margin: 0,
	top: 100,
	right: 80,
	left: 'auto',
	position: 'fixed',
};

const columnKeys = [
	'name',
	'email',
	'blocked',
	'active',
	'canDelete'
];

const defaultSort = {
	sortBy: 'name',
	sortDirection: 'asc'
};

export class UserList extends Component {

	state = {
		sort: defaultSort,
	};

	render() {
		const {
			router,
			viewer: { usersPaginate },
		} = this.props;

		return (
			<Paper style={{ padding: 16 }}>
				<h4>Админы</h4>
				<Table>
					<TableHeader displaySelectAll={false} adjustForCheckbox={false}>
						<TableRow selectable={true} onCellClick={this.handleSort} >
							<TableHeaderColumn>
								<div className="sortedLabel">
									Имя {this.renderSortIcon('name')}
								</div>
							</TableHeaderColumn>
							<TableHeaderColumn>
								<div className="sortedLabel">
									Email {this.renderSortIcon('email')}
								</div>
							</TableHeaderColumn>
							<TableHeaderColumn>
								<div className="sortedLabel">
									Blocked {this.renderSortIcon('blocked')}
								</div>
							</TableHeaderColumn>
							<TableHeaderColumn>
								<div className="sortedLabel">
									Active {this.renderSortIcon('active')}
								</div>
							</TableHeaderColumn>
							<TableHeaderColumn>
								<div className="sortedLabel">
									Can delete {this.renderSortIcon('canDelete')}
								</div>
							</TableHeaderColumn>
						</TableRow>
					</TableHeader>
					<TableBody showRowHover stripedRows>
						{usersPaginate.users.map(user => <UserListItem key={user.__id} user={user} router={router} viewer={this.props.viewer} />)}
					</TableBody>
				</Table>

				<RaisedButton label="ДОБВИТЬ ПОЛЬЗОВАТЕЛЯ" primary={true} style={fabStyle} onClick={this.handleClick} />
			</Paper>
		);
	}

	handleClick = () => {
		const { history } = this.props;
		history.push(`/users/new`);
	}

	renderSortIcon = field => {
		const { sort: { sortBy, sortDirection} } = this.state;
		if (field === sortBy) {
			return sortDirection === 'asc' ? <IconArrowUp /> : <IconArrowDown/>
		}
		return null
	}

	handleSort = (event, rotNumber, columnIndex) => {
		const field = columnKeys[columnIndex - 1];
		const { relay } = this.props;
		const { sortBy, sortDirection } = this.state.sort;
		let updatedDirection = 'asc';
		if (sortBy === field) {
			updatedDirection = sortDirection === 'asc' ? 'desc' : 'asc';
		}
		const updatedSort = {
			sortBy: field,
			sortDirection: updatedDirection
		};
		relay.refetch(updatedSort, null, () => {
			this.setState({ sort: updatedSort })
		});
	}
}

export default withRouter(createRefetchContainer(
	UserList,
	graphql`
		fragment UserList_viewer on Viewer @argumentDefinitions(
			sortBy: {type: "String"},
            sortDirection: {type: "String"}
		) {
			usersPaginate(sortBy: $sortBy, sortDirection: $sortDirection ) {
				users {
					...UserListItem_user
				}
			}
		}
	`,
	graphql`
		query UserList_Refetch_Query (
			$sortBy: String,
            $sortDirection: String
		) {
			viewer {
                ...UserList_viewer @arguments ( sortBy: $sortBy, sortDirection: $sortDirection )
			}
		}`
	)
);



// WEBPACK FOOTER //
// src/components/users/UserList.js